module.exports = __webpack_public_path__ + "static/media/Schritt_4_Notfallsituation_Torben_Teller.e6242e7e.pdf";